import { useMemo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { TRANSLATION_KEYS } from 'partner360/widgets/gp360Administration/translations'

import styles from './ClipboardResultModalContent.module.scss'

interface IProps {
  payloadCount: number
  responseCount: number
  unmatchedValues: string[]
  onClose: () => void
  onAgree: () => void
}

export const ClipboardResultModalContent = ({
  payloadCount,
  responseCount,
  unmatchedValues,
  onClose,
  onAgree,
}: IProps) => {
  const unmatchedValuesToDisplay = useMemo(() => unmatchedValues.join(', '), [unmatchedValues])

  return (
    <div className={styles.root}>
      <div>
        <Translation span text={TRANSLATION_KEYS.pasteFromClipboard.clipboardPayloadCount} />
        :&nbsp;
        <span>{payloadCount}</span>
      </div>
      <div>
        <Translation span text={TRANSLATION_KEYS.pasteFromClipboard.clipboardResponseCount} />
        :&nbsp;
        <span>{responseCount}</span>
      </div>
      <div>
        <Translation span text={TRANSLATION_KEYS.pasteFromClipboard.clipboardUnmatched} />
        :&nbsp;
        <span>{unmatchedValuesToDisplay || '-'}</span>
      </div>
      <div className={styles.wantSaveBlock}>
        <Translation span text={TRANSLATION_KEYS.pasteFromClipboard.wantSave} />
      </div>
      <div className={styles.btnWrapper}>
        <Button onClick={onAgree}>
          <Translation text={TRANSLATION_KEYS.pasteFromClipboard.resultApply} />
        </Button>
        <Button onClick={onClose} color={'danger'}>
          <Translation text={TRANSLATION_KEYS.pasteFromClipboard.resultCancel} />
        </Button>
      </div>
    </div>
  )
}
